<template>
  <div class="container-resumo-pacientes">
    <div class="header-resumo-pacientes">
      <span>Pacientes ortodontia</span>
    </div>
    <div v-if="resumo">
      <apexchart
          v-if="series.length && resumo.quantidadeCadastros > 0"
          type="pie"
          height="300"
          :options="chartOptions"
          :series="series"
      />
    </div>
  </div>
</template>

<script>

export default {
    name: 'ResumoPacientesOrtodontia',
    props: {
        resumo: Object
    },
    computed: {
        outros() {
            return Math.max(this.resumo.quantidadeCadastros - this.resumo.quantidadeOrtodontia, 0)
        },
        series() {
            return [this.resumo.quantidadeOrtodontia, this.outros]
        },
        chartOptions() {
            return {
                labels: ['Ortodontia', 'Outros'],
                colors: ['#00E396', '#E0E0E0'],
                legend: {
                    position: 'bottom'
                },
                dataLabels: {
                    enabled: true,
                    formatter: (val) => `${val.toFixed(1)}%`
                },
                tooltip: {
                    y: {
                        formatter: (value) =>
                            `${value} pacientes (${((value / this.resumo.quantidadeCadastros) * 100).toFixed(1)}%)`
                    }
                }
            }
        }
    }
}
</script>


<style scoped lang="stylus">

.container-resumo-pacientes
  box-shadow rgba(0, 0, 0, 0.2) 0px 12px 28px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px, rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset
  border-radius 5px
  height 350px

.header-resumo-pacientes
  padding-left 5px
  height 41.59px
  display flex
  align-items center
  border-bottom 1px solid #ddd
  font-weight bold
  color var(--theme-primary)

</style>